// ** Components
import { PersonCard } from '@/components/common/PersonCards';

// ** Types
import type { StrapiComponentElementProps } from '@/types/strapi';
import type { ComponentElementsPersonCard as ElementsPersonCardProps } from '@/types/graphql';

type ComponentElementsPersonCardProps = StrapiComponentElementProps<Omit<ElementsPersonCardProps, 'id' | 'personName'>>;

const ComponentElementsPersonCard = ({ individual, host }: ComponentElementsPersonCardProps) => {
	if (!individual || !host) return null;

	const {
		documentId,
		firstName,
		lastName,
		profilePicture,
		telephone,
		email,
		positionLine1,
		positionLine2,
		positionLine3
		// linkedinUrl
	} = individual;

	const name = `${firstName || ''} ${lastName || ''}`.trim();

	const roleLines = [positionLine1, positionLine2, positionLine3].filter((line): line is string => Boolean(line));

	return (
		<PersonCard
			id={documentId || ''}
			name={name}
			roleLines={roleLines}
			imageSrc={undefined}
			imageAlt={profilePicture?.alternativeText || name}
			host={host}
			linkedinUrl={undefined}
			phone={telephone || undefined}
			email={email || undefined}
			team="all"
			imageData={profilePicture}
		/>
	);
};

export default ComponentElementsPersonCard;
